import { useRouter } from 'next/router'
import { useSession } from 'next-auth/react'
import { ReactElement } from 'react'

import { Loading } from '@/components/uiParts/legacy/Loading'
import { PermissionGroup } from '@/types/common/index.d'
import {
  hasViewPermission,
  redirectToAllowedPage,
  hasViewPermissionDeprecated,
} from '@/utils/authUtils'
import { useUsersMeRetrieve } from '@api'

type PropsType = {
  children: ReactElement
  requiredGroups: PermissionGroup[]
  /** @deprecated requiredGroups を使ったロール(Users - Group)ベースの権限管理に移行します */
  is_portrich?: boolean
  /** @deprecated 別のレイヤーで扱うので引数から削除します */
  role: 'admin' | 'user'
}

/**
 * ユーザーの権限をチェックし、必要な権限を持っている場合にのみchildrenを表示するコンポーネント。
 * ユーザーが必要な権限を持っていない場合、適切なページにリダイレクトします。
 */
export const AuthCheck = ({
  children,
  requiredGroups,
  is_portrich = false,
  role,
}: PropsType) => {
  const router = useRouter()
  const { status } = useSession({ required: true })
  const { data: user } = useUsersMeRetrieve({
    swr: { enabled: status === 'authenticated' },
  })

  if (!user) return <Loading />

  if (
    !hasViewPermission(user, requiredGroups) &&
    !hasViewPermissionDeprecated(user, is_portrich, role)
  ) {
    router.replace(redirectToAllowedPage(user))
    return null
  }

  // 高権限ユーザーのみchildren表示
  return children
}
